// frontend/shared-ui/src/components/Badge.jsx
import React from "react";

export default function Badge({
  children,
  variant = "default",
  dot = false,
  className = "",
}) {
  return (
    <span className={`fh-badge fh-badge--${variant} ${className}`}>
      {dot && <span className="fh-badge__dot" />}
      {children}
    </span>
  );
}
